// The footer: the slogan in full, every section, and the small print.
import { Rss } from "@phosphor-icons/react";
import { Link } from "react-router";

import { Mark } from "./Logo";
import { APP_URL } from "./nav";

const COLUMNS = [
  { title: "The movement", links: [["/charter", "The Charter"], ["/community", "Community"], ["/about", "Our story"]] },
  { title: "Learn", links: [["/learn", "Secure your access"], ["/blog", "Blog"], ["/portable-workflows", "Portable workflows"]] },
  { title: "Build", links: [["/products", "Products"], ["/workflows", "Workflow marketplace"], ["/tools", "Free tools"]] },
] as const;

export function Footer() {
  return (
    <footer className="mt-24 bg-ink text-paper">
      <div className="wrap py-16">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <Mark className="h-10 w-10 text-paper" />
            <p className="display mt-6 max-w-md text-[2.4rem] sm:text-5xl">
              No one marks their own <span className="text-signal">homework.</span>
            </p>
            <p className="mt-4 max-w-sm font-serif text-lg text-paper/70">A community keeping AI accountable: we teach, we build in the open, and we set the bar together.</p>
          </div>
          {COLUMNS.map((c) => (
            <div key={c.title}>
              <p className="font-mono text-[11px] uppercase tracking-[0.16em] text-paper/50">{c.title}</p>
              <ul className="mt-4 space-y-2.5">
                {c.links.map(([to, label]) => (
                  <li key={to}>
                    <Link to={to} className="text-[15px] text-paper/85 hover:text-signal">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-16 flex flex-col gap-4 border-t border-paper/15 pt-6 text-[13px] text-paper/55 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} OpenCloudSecurity.</p>
          <div className="flex items-center gap-5">
            <Link to="/privacy" className="hover:text-paper">
              Privacy
            </Link>
            <a href="/rss.xml" className="inline-flex items-center gap-1 hover:text-paper">
              <Rss className="h-3.5 w-3.5" aria-hidden /> RSS
            </a>
            <a href={APP_URL} className="hover:text-paper">
              Sign in to OCS
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
